import React from 'react';

// Import your logo assets from the folder shown in your screenshot
import booking from '/assets/LOGO/Booking.com.svg';
import klook from '/assets/LOGO/KLOOK.svg';
import agoda from '/assets/LOGO/Agoda_logo_2019.svg';
import viator from '/assets/LOGO/viator.com logo9.svg';
import expedia from '/assets/LOGO/expedia.co.in logo10.svg';
import getYourGuide from '/assets/LOGO/getyourguide.com logo11.svg';
// import getTransfer from './assets/LOGO/gettransfer.com logo10.svg';
import ogImage from '/assets/LOGO/og-image.png';
import bigBus from '/assets/LOGO/BigBus.svg';
import logo12Go from '/assets/LOGO/12go.asia logo17.svg';

const BrandsSection = () => {
    // Array of all logos
    const logos = [
        { src: booking, alt: 'Booking.com' },
        { src: klook, alt: 'Klook' },
        { src: agoda, alt: 'Agoda' },
        { src: viator, alt: 'Viator' },
        { src: expedia, alt: 'Expedia' },
        { src: getYourGuide, alt: 'Get Your Guide' },
        // { src: getTransfer, alt: 'Get Transfer', },
        { src: ogImage, alt: 'OG Image', className: 'max-w-[160px] sm:max-w-[180px] lg:max-w-[200px] max-h-[52px] sm:max-h-[58px] lg:max-h-[66px]' },
        { src: bigBus, alt: 'BigBus' },
        { src: logo12Go, alt: '12Go Asia' }
    ];

    return (
        <section className="w-full bg-white py-3 sm:py-10 md:py-12 lg:py-14 overflow-hidden flex justify-center">

            {/* Inline styles for the infinite marquee animation and edge fading */}
            <style>{`
                @keyframes scroll-left {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                
                .animate-infinite-scroll {
                    display: flex;
                    width: max-content;
                    animation: scroll-left 25s linear infinite;
                }

                .animate-infinite-scroll:hover {
                    animation-play-state: paused;
                }

                /* 
                 * ENHANCED FADE EFFECT: 
                 * Increased the transparent zones to 20% and 80% to match the deep fade in your reference image.
                 */
                .fade-edges {
                    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%);
                    mask-image: linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%);
                }
            `}</style>

            {/* Main Container */}
            <div className="w-full max-w-[1500px] px-4 sm:px-8 xl:px-12 flex flex-col items-center">

                {/* Title Section with Red Underline */}
                <div className="text-center mb-6 sm:mb-8 lg:mb-10 flex flex-col items-center">
                    <h2 className="text-[#000000] text-lg sm:text-xl md:text-2xl lg:text-[20px]  font-semibold font-poppins uppercase tracking-wide mb-4">
                        Trusted by Travel & Tourism Brands
                    </h2>
                    {/* <div className="  md:w-40 lg:w-20 h-1 bg-[#d02525] mt+2 mx-auto" aria-hidden="true"></div> */}
                    {/* The short red underline */}
                    {/* <div className="w-12 sm:w-16 h-[2px] sm:h-[3px] bg-[#E53935] rounded-full mx-auto"></div> */}
                </div>

                {/* Scrolling Logos Carousel with the deep fade effect */}
                <div className="w-full relative fade-edges">
                    <div className="animate-infinite-scroll items-center">

                        {/* First Set of Logos */}
                        <div className="flex items-center w-max gap-x-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-10">
                            {logos.map((logo, index) => (
                                <div
                                    key={`set1-${index}`}
                                    className="flex items-center justify-center shrink-0 w-[120px] sm:w-[140px] md:w-[160px] lg:w-[180px] h-[60px] sm:h-[70px] lg:h-[80px]"
                                >
                                    <img
                                        src={logo.src}
                                        alt={logo.alt}
                                        className={`${logo.className ?? 'max-w-[100px] sm:max-w-[120px] lg:max-w-[140px] max-h-[32px] sm:max-h-[40px] lg:max-h-[48px]'} w-auto h-auto object-contain mix-blend-multiply opacity-90 hover:opacity-100 transition-opacity duration-300`}
                                    />
                                </div>
                            ))}
                        </div>

                        {/* Second Set of Logos (Duplicate for perfectly seamless loop) */}
                        <div className="flex items-center w-max gap-x-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-10">
                            {logos.map((logo, index) => (
                                <div
                                    key={`set2-${index}`}
                                    className="flex items-center justify-center shrink-0 w-[120px] sm:w-[140px] md:w-[160px] lg:w-[180px] h-[60px] sm:h-[70px] lg:h-[80px]"
                                >
                                    <img
                                        src={logo.src}
                                        alt={logo.alt}
                                        className={`${logo.className ?? 'max-w-[100px] sm:max-w-[120px] lg:max-w-[140px] max-h-[32px] sm:max-h-[40px] lg:max-h-[48px]'} w-auto h-auto object-contain mix-blend-multiply opacity-90 hover:opacity-100 transition-opacity duration-300`}
                                    />
                                </div>
                            ))}
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default BrandsSection;